import Map from './components/Map/Map';
import Sidebar from './components/Sidebar/Sidebar';

function App() {
  return (
    <div className="app-container">
      <div className="map-container">
        <Map />
      </div>
      <Sidebar />
    </div>
  );
}

export default App;
